import { render, staticRenderFns } from "./TableClasses.vue?vue&type=template&id=332ea9a5&"
import script from "./TableClasses.vue?vue&type=script&lang=js&"
export * from "./TableClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports